import React from 'react';

import { Box, Button, Flex, Text } from '@rover/kibble/core';

import {
  BADGE_DIGIT_OPTICAL_OFFSET,
  BADGE_RING_PX,
  BUTTON_SIZE_TO_BADGE_OFFSET_MAP,
  BUTTON_SIZE_TO_BADGE_SIZE_MAP,
  ButtonWithCountBadgeWebProps,
  isPillBadge,
} from './ButtonWithCountBadge.common';

const ButtonWithCountBadge = ({
  badgeCount,
  ariaLabel,
  badgeTestID,
  // Consumed here so it is not spread onto the DOM Button. Native-only behavior.
  hideBadgeFromScreenReader: _hideBadgeFromScreenReader, // eslint-disable-line @typescript-eslint/no-unused-vars
  onClick,
  size = 'default',
  ...otherProps
}: ButtonWithCountBadgeWebProps): JSX.Element => {
  const badgeSize = BUTTON_SIZE_TO_BADGE_SIZE_MAP[size];
  const { top, right } = BUTTON_SIZE_TO_BADGE_OFFSET_MAP[size];
  const isPill = isPillBadge(badgeCount, size);

  return (
    <Flex alignItems="center">
      <Box position="relative">
        {badgeCount ? (
          <Box
            data-testid={badgeTestID}
            background="notification"
            borderColor="border.surface"
            borderStyle="solid"
            borderRadius="round"
            justifyContent="center"
            alignItems="center"
            height={badgeSize}
            width={isPill ? 'auto' : badgeSize}
            minWidth={badgeSize}
            px={isPill ? '1x' : '0x'}
            sx={{
              position: 'absolute',
              borderWidth: 'primary',
              top: top - BADGE_RING_PX,
              left: `calc(100% - ${right + badgeSize + BADGE_RING_PX}px)`,
              zIndex: 1,
              display: 'flex',
              boxSizing: 'content-box',
            }}
          >
            <Text
              size="50"
              fontWeight="semibold"
              textColor="primary_inverse"
              textAlign="center"
              sx={{
                lineHeight: 1,
                whiteSpace: 'nowrap',
                fontVariantNumeric: 'tabular-nums',
                transform: `translateY(${BADGE_DIGIT_OPTICAL_OFFSET}px)`,
              }}
            >
              {badgeCount}
            </Text>
          </Box>
        ) : null}
        <Button onClick={onClick} size={size} aria-label={ariaLabel} {...otherProps} />
      </Box>
    </Flex>
  );
};

export default ButtonWithCountBadge;
